import { Typography } from '@mui/material';
import Stages from '../../components/components/Stages';

export default function ConsultsComplete() {
  return (
    <>
      <Typography variant="h4" component="h1" sx={(theme) => ({ color: theme.palette.primary.main })}>
        Consultations complete!
      </Typography>

      <Stages stage={3} />
    </>
  );
}
